import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { PartnerPipe } from './pipes/partner-pipe';

@NgModule({
  declarations: [
    PartnerPipe
  ],
  imports: [
    CommonModule,
    HttpClientModule,
  ]
})
export class KernelModule { }
